import { FormattedMessage } from 'react-intl'

import Button from 'app/components/base/Button'
import ChangeAddressDialog from 'app/features/ListingFeature/components/dialogs/ChangeAddressDialog'
import useModal from 'app/hooks/useModal'

interface ChangeAddressButtonProps {
  addressOptions: { id?: string | number; address: string }[]
  calculateShippingCost: (address: Address) => Promise<void>
}

const ChangeAddressButton: RFC<ChangeAddressButtonProps> = ({
  addressOptions,
  calculateShippingCost
}) => {
  const { open, hideModal, showModal } = useModal()

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        sx={{ maxWidth: 187 }}
        onClick={showModal}
      >
        <FormattedMessage defaultMessage="Change Address" />
      </Button>

      {!!open && (
        <ChangeAddressDialog
          open={open}
          onClose={hideModal}
          options={addressOptions}
          calculateShippingCost={calculateShippingCost}
        />
      )}
    </>
  )
}

export default ChangeAddressButton
